import { render, staticRenderFns } from "./omt-highlight.vue?vue&type=template&id=0f04b12d&scoped=true&"
var script = {}
import style0 from "./omt-highlight.vue?vue&type=style&index=0&id=0f04b12d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04b12d",
  null
  
)

export default component.exports